/**
 * @license
 * Copyright (c) 2023 Valentin Degenne
 * SPDX-License-Identifier: MIT
 */
suite('UpdateController', () => {
	test('first host can be passed into the constructor')

	test("shouldn't update if the host is not connected")

	test('`remoteUpdateComplete` awaits every hosts to finish to update')
})
